<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row ">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">College Register Detail Report</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <div class="row">
                            <div class="form-group col-lg-4 col-md-12 col-12">
                                <label><b>College Name</b><span class="text-danger">*</span></label>
                                <select class="form-control" #CollegeID="ngModel" ngModel name="CollegeID"
                                    id="CollegeID" [(ngModel)]="data.CollegeID" required>
                                    <option *ngFor="let c of colleges" [value]="c.value"
                                        [selected]="data.CollegeID == c.value">
                                        {{ c.text }}
                                    </option>
                                </select>
                                <!-- <span *ngIf="collegewiseForm.submitted && collegewiseForm.invalid">
                                        <p *ngIf="collegewiseForm.errors.required" class="error_message"
                                            style="color: red;">
                                            College name is required
                                        </p>
                                    </span> -->
                            </div>
                            <div class="form-group col-lg-4 col-md-12 col-12">
                                <label><b>From Date:</b><span class="text-danger">*</span></label>
                                <input type="date" placeholder="Select Date" id="fromDate" class="form-control"
                                    #fromDate="ngModel" ngModel name="fromDate" [(ngModel)]="data.fromDate" required>
                                <!-- <span *ngIf="collegewiseForm.submitted && collegewiseForm.invalid">
                                    <p *ngIf="collegewiseForm.errors.required" class="error_message"
                                        style="color: red;">
                                        From date is required
                                    </p>
                                </span> -->
                            </div>
                            <div class="form-group col-lg-4 col-md-12 col-12">
                                <label><b>To Date</b><span class="text-danger">*</span></label>
                                <input type="date" placeholder="Select Date" id="toDate" class="form-control"
                                    #toDate="ngModel" ngModel name="toDate" [(ngModel)]="data.toDate" required>
                                <!-- <span *ngIf="collegewiseForm.submitted && collegewiseForm.invalid">
                                        <p *ngIf="collegewiseForm.errors.required" class="error_message"
                                            style="color: red;">
                                            From date is required
                                        </p>
                                    </span> -->
                            </div>
                            <div class="form-group col-lg-4 col-md-12 col-12">
                                <label>Status
                                </label>
                                <select class="form-control" #Status name="Status" id="Status">
                                    <option value="0" selected>All</option>
                                    <option value="1">Approved</option>
                                    <option value="2">Reject</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-lg-1 col-md-1 col-5">
                                <button type="button" (click)="onSubmit()"
                                    class="col-lg-12 btn btn-primary mr-3">Show</button>
                            </div>
                            <!-- <div class="form-group col-lg-4 col-md-2 col-2">
                                <button type="button" id="btnExcel" (click)="ExportToExcel()" style="display: none;"
                                    class="btn btn-primary  mr-3">Export to
                                    excel</button>
                            </div> -->
                            <div class="form-group col-lg-4 col-md-2 col-7">
                                <button type="button" id="btnpdf" (click)="downloadAsPDF()" style="display: none;"
                                    class="btn btn-primary  mr-3">Export To PDF </button>
                            </div>
                        </div>
                        <div class="row" id="divclgList" style="display: none;">
                            <div class=" col-lg-12 col-md-12 col-12 p-4">
                                <div class="table-responsive">
                                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                                        <thead>
                                            <tr>
                                                <!-- <th class="pointer"(click)="sortBy('Board')">Name</th> -->
                                                <th class="pointer" scope="col">University</th>
                                                <th class="pointer" scope="col">Medium</th>
                                                <th class="pointer" scope="col">Area</th>
                                                <th class="pointer" scope="col">State</th>
                                                <th class="pointer" scope="col">City</th>
                                                <th class="pointer" scope="col">Registration date</th>
                                                <th class="pointer" scope="col">College name</th>
                                                <th class="pointer" scope="col">College address</th>
                                                <th class="pointer" scope="col">College pincode</th>
                                                <th class="pointer" scope="col">College contact / mobile no</th>
                                                <th class="pointer" scope="col">College mail id</th>
                                                <th class="pointer" scope="col">College location</th>
                                                <th class="pointer" scope="col">College type</th>
                                            </tr>
                                        </thead>
                                        <tbody style="font-size: small;">
                                            <tr *ngFor="let r of collegeregistrationlist;let i = index">
                                                <td>{{r.Board}}</td>
                                                <td>{{r.Medium}}</td>
                                                <td>{{r.Area}}</td>
                                                <td>{{r.State}}</td>
                                                <td>{{r.City}}</td>
                                                <td>
                                                    <p>{{r.RegistrationDate}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolName}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolAddress}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.Pincode}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolMobileno}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolMailID}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolLocation}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.SchoolType}}</p>
                                                </td>



                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- <div class="card-footer pb-3 pt-3 mb-4" align="center">
                                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                                </div> -->
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

   
        <div class="row card">
            <div class="col-lg-12">
                <div class="row justify-content-center">
                    <!-- <div class="col-lg-12 col-md-12 col-12 p-4"> -->
                        <div class="border mt-3 verify" *ngIf="collegeregistrationlist!= undefined">
                            <!-- <div class="row">
                            <div class="col-lg-12">
                                <h4 class="mb-0 v_title"> &nbsp; College Information</h4>
                            </div>
                        </div> -->
                            <div class="row p-3">
                                <div class="col-lg-6 col-md-6 col-sm-6" id="pdfTable" #pdfTable style="display: none;">
                                    <div class="table-responsive">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <tr>
                                                    <td width="50%">
                                                        <b>{{collegeregistrationlist[0]["SchoolName"]}}</b>
                                                    </td>
                                                </tr>
                                                <h4>College Information</h4>
                                            </div>
                                        </div>
                                        <table class="table table-borderless mb-0" style="font-size:7pt;">
                                            <tbody>
                                                <tr>

                                                    <td width="50%">
                                                        <p><strong>College name:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["SchoolName"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College address:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["SchoolAddress"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College pincode:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["Pincode"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College contact / mobile no:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["SchoolMobileno"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College mail id:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["SchoolMailID"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College location:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["SchoolLocation"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>College type:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["SchoolType"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>State:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["State"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>City:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["City"]}}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="50%">
                                                        <p><strong>Area:</strong></p>
                                                    </td>
                                                    <td width="50%">
                                                        <p>{{collegeregistrationlist[0]["Area"]}}</p>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="border border-dark bg-custom p-2">
                                        <div class="table-responsive">
                                            <table class="table table-bordered" style="font-size:7pt;">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <h6 class="mb-0 v_title">Trustee's Details :</h6>
                                                    </div>
                                                </div>
                                                <thead>

                                                    <tr>
                                                        <th>Trustee's name</th>
                                                        <th>Trustee's address</th>
                                                        <th>Trustee's contact / mobile no.</th>
                                                        <th>Trustee's mail id</th>
                                                    </tr>
                                                </thead>
                                                <tbody
                                                    *ngIf="Trusteecollegewiselist != undefined && Trusteecollegewiselist.length != 0">
                                                    <tr *ngFor="let t of Trusteecollegewiselist;">
                                                        <td>{{t.TrusteeName}}</td>
                                                        <td>{{t.TrusteeAddress}}</td>
                                                        <td>{{t.TrusteeMobileNo}}</td>
                                                        <td>{{t.TrusteeMailID}}</td>
                                                    </tr>
                                                </tbody>
                                                <tbody
                                                    *ngIf="Trusteecollegewiselist == undefined || Trusteecollegewiselist.length == 0">
                                                    <tr>
                                                        <td colspan="4" style="text-align: center;">
                                                            No record found
                                                        </td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Principal Details:</h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Principal Name</th>
                                                            <th scope="col">Designation</th>
                                                            <th scope="col">Principal Mobile No</th>
                                                            <th scope="col">Principal MailID</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="Principalcollegewiselist != undefined && Principalcollegewiselist.length != 0">
                                                        <tr *ngFor="let P of Principalcollegewiselist">

                                                            <td>
                                                                <p>{{P.PrincipalName}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{P.Designation}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{P.PrincipalMobileNo}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{P.PrincipalMailID}}</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="Principalcollegewiselist == undefined || Principalcollegewiselist.length == 0">
                                                        <tr>
                                                            <td colspan="4" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title"><b>Employee Details:</b></h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col"><b>Employee Type</b></th>
                                                            <th scope="col">No Of Permanent Employee</th>
                                                            <th scope="col">No Of AdHoc Employee</th>
                                                            <th scope="col">Total Permanent Salary.</th>
                                                            <th scope="col">Total Adhoc Salary</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="employeecollegewiselist != undefined && employeecollegewiselist.length != 0">
                                                        <tr *ngFor="let e of employeecollegewiselist">
                                                            <td>
                                                                <p>{{e.EmployeeType}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{e.NoOfPermanentEmployee}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{e.NoOfAdHocEmployee}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{e.TotalPermanentSalary}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{e.TotalAdhocSalary}}</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="employeecollegewiselist == undefined || employeecollegewiselist.length == 0">
                                                        <tr>
                                                            <td colspan="5" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Employee Qualification Details:
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <thead>

                                                        <tr>
                                                            <!-- <th scope="col">QualificationID</th> -->
                                                            <th scope="col">No of Employee</th>
                                                            <th scope="col">Qualification Type </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="employeequalificationcollegewiselist != undefined && employeequalificationcollegewiselist.length != 0">
                                                        <tr *ngFor="let Q of employeequalificationcollegewiselist">

                                                            <td>
                                                                <p>{{Q.NoofEmployee}}</p>
                                                            </td>
                                                            <td>
                                                                <p>{{Q.QualificationType}}</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="employeequalificationcollegewiselist == undefined || employeequalificationcollegewiselist.length == 0">
                                                        <tr>
                                                            <td colspan="2" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title"><b>Course Details:</b></h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Course</th>
                                                            <th scope="col">Division details (Division Name - Student
                                                                Counts)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="standardcollegewiselist != undefined && standardcollegewiselist.length != 0">
                                                        <tr *ngFor="let sta of standardcollegewiselist">
                                                            <td>{{sta.Standard}}</td>
                                                            <td>{{sta.DivisionDetail}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="standardcollegewiselist == undefined || standardcollegewiselist.length == 0">
                                                        <tr>
                                                            <td colspan="2" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Fees Increase Detail:</h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">RequestDate</th>
                                                            <th scope="col">AcademicYear</th>
                                                            <th scope="col">Medium</th>
                                                            <th scope="col">Course</th>
                                                            <th scope="col">InstituteType</th>
                                                            <th scope="col">CourseYear</th>
                                                            <th scope="col">TotalAmount</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="FeesIncreaseDetaillist != undefined && FeesIncreaseDetaillist.length != 0">
                                                        <tr *ngFor="let fees of FeesIncreaseDetaillist">
                                                            <td>{{fees.RequestDate}}</td>
                                                            <td>{{fees.AcademicYear}}</td>
                                                            <td>{{fees.Medium}}</td>
                                                            <td>{{fees.Course}}</td>
                                                            <td>{{fees.InstituteType}}</td>
                                                            <td>{{fees.CourseYear}}</td>
                                                            <td>{{fees.TotalAmount}}</td>
                                                            <td>{{fees.StatusData}}</td>
                                                            <td>{{fees.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="FeesIncreaseDetaillist == undefined || FeesIncreaseDetaillist.length == 0">
                                                        <tr>
                                                            <td colspan="9" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Bookwise Detail:</h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Academic Year</th>
                                                            <th scope="col">University</th>
                                                            <th scope="col">Medium</th>
                                                            <th scope="col">Course</th>
                                                            <th scope="col">Institute Type</th>
                                                            <th scope="col">No Of Books</th>
                                                            <th scope="col">Book Title</th>
                                                            <th scope="col">Total Amount</th>
                                                            <th scope="col">Status</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="pendingbookcollewiselist != undefined && pendingbookcollewiselist.length != 0">
                                                        <tr *ngFor="let pen of pendingbookcollewiselist">
                                                            <td>{{pen.RequestDate}}</td>
                                                            <td>{{pen.AcademicYear}}</td>
                                                            <td>{{pen.Board}}</td>
                                                            <td>{{pen.Medium}}</td>
                                                            <td>{{pen.Course}}</td>
                                                            <td>{{pen.InstituteType}}</td>
                                                            <td>{{pen.NoOfBooks}}</td>
                                                            <td>{{pen.BookTitle}}</td>
                                                            <td>{{pen.TotalAmount}}</td>
                                                            <td>{{pen.StatusData}}</td>

                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="pendingbookcollewiselist == undefined || pendingbookcollewiselist.length == 0">
                                                        <tr>
                                                            <td colspan="10" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Establishment Detail:
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <!-- <th scope="col">Academic Year</th> -->
                                                            <th scope="col">University</th>
                                                            <th scope="col">Medium</th>
                                                            <th scope="col">Faculty</th>
                                                            <th scope="col">Course</th>
                                                            <th scope="col">Institute Type</th>
                                                            <th scope="col">Establishment Date</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="establishmentDetaillist != undefined && establishmentDetaillist.length != 0">
                                                        <tr *ngFor="let est of establishmentDetaillist">
                                                            <td>{{est.RequestDate}}</td>
                                                            <!-- <td>{{est.AcademicYear}}</td> -->
                                                            <td>{{est.Board}}</td>
                                                            <td>{{est.Medium}}</td>
                                                            <td>{{est.Section}}</td>
                                                            <td>{{est.Course}}</td>
                                                            <td>{{est.InstituteType}}</td>
                                                            <td>{{est.EstablishmentDate}}</td>
                                                            <td>{{est.StatusData}}</td>
                                                            <td>{{est.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="establishmentDetaillist == undefined || establishmentDetaillist.length == 0">
                                                        <tr>
                                                            <td colspan="9" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title" style="font-size:14pt;">
                                                                Document Upload Detail:
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Course</th>
                                                            <th scope="col">Institute Type</th>
                                                            <th scope="col">Section</th>
                                                            <th scope="col">Medium</th>
                                                            <th scope="col">Academic Year</th>
                                                            <th scope="col">Document Name</th>
                                                            <th scope="col">Amount</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="SchoolDocumentUpcollwiseReqList != undefined && SchoolDocumentUpcollwiseReqList.length != 0">
                                                        <tr *ngFor="let scd of SchoolDocumentUpcollwiseReqList">
                                                            <td>{{scd.RequestDate}}</td>
                                                            <td>{{scd.Course}}</td>
                                                            <td>{{scd.InstituteType}}</td>
                                                            <td>{{scd.Section}}</td>
                                                            <td>{{scd.MediumName}}</td>
                                                            <td>{{scd.AcademicYear}}</td>
                                                            <td>{{scd.DocumentName}}</td>
                                                            <td>{{scd.Amount}}</td>
                                                            <td>{{scd.StatusData}}</td>
                                                            <td>{{scd.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="SchoolDocumentUpcollwiseReqList == undefined || SchoolDocumentUpcollwiseReqList.length == 0">
                                                        <tr>
                                                            <td colspan="10" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Employee
                                                                Additional Detail:</h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Employee Name</th>
                                                            <th scope="col">Employee Type</th>
                                                            <th scope="col">Employee position</th>
                                                            <th scope="col">Qualification type</th>
                                                            <th scope="col">Employee additional qualification</th>
                                                            <th scope="col">Employee yearly salary</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="pendingempcollwiselist != undefined && pendingempcollwiselist.length != 0">
                                                        <tr *ngFor="let pemp of pendingempcollwiselist">
                                                            <td>{{pemp.RequestDate}}</td>
                                                            <td>{{pemp.EmpName}}</td>
                                                            <td>{{pemp.EmpType}}</td>
                                                            <td>{{pemp.EmpPosition}}</td>
                                                            <td>{{pemp.QualificationType}}</td>
                                                            <td>{{pemp.EmpAdditionalQualification}}</td>
                                                            <td>{{pemp.EmpSalary}}</td>
                                                            <td>{{pemp.StatusData}}</td>
                                                            <td>{{pemp.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="pendingempcollwiselist == undefined || pendingempcollwiselist.length == 0">
                                                        <tr>
                                                            <td colspan="9" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Expense Detail:
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Expense Type</th>
                                                            <th scope="col">Expense Amount</th>
                                                            <th scope="col">Name Tax</th>
                                                            <th scope="col">Tax trust</th>
                                                            <th scope="col">Tax College</th>
                                                            <th scope="col">Student Ins</th>
                                                            <th scope="col">Teach Ins</th>
                                                            <th scope="col">NonTeach Ins</th>
                                                            <th scope="col">Building Ins</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="PendingExpenscollegeList != undefined && PendingExpenscollegeList.length != 0">
                                                        <tr *ngFor="let pexpe of PendingExpenscollegeList">
                                                            <td>{{pexpe.RequestDate}}</td>
                                                            <td>{{pexpe.ExpenseType}}</td>
                                                            <td>{{pexpe.ExpenseAmount}}</td>
                                                            <td>{{pexpe.NameOfTax}}</td>
                                                            <td>{{pexpe.TaxByTrust}}</td>
                                                            <td>{{pexpe.TaxByCollege}}</td>
                                                            <td>{{pexpe.StudentInsurance}}</td>
                                                            <td>{{pexpe.TeachingInsurance}}</td>
                                                            <td>{{pexpe.NonTeachingInsurance}}</td>
                                                            <td>{{pexpe.BuildingInsurance}}</td>
                                                            <td>{{pexpe.StatusData}}</td>
                                                            <td>{{pexpe.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="PendingExpenscollegeList == undefined || PendingExpenscollegeList.length == 0">
                                                        <tr>
                                                            <td colspan="12" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Scholarship Detail:
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Course</th>
                                                            <th scope="col">Medium</th>
                                                            <th scope="col">Institute Type</th>
                                                            <th scope="col">AcademicYear</th>
                                                            <th scope="col">GrNo</th>
                                                            <!-- <th scope="col">StudName</th> -->
                                                            <th scope="col">ScholarshipType</th>
                                                            <th scope="col">Amount</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="scholarshipDetcolleList != undefined && scholarshipDetcolleList.length != 0">
                                                        <tr *ngFor="let scholar of scholarshipDetcolleList">
                                                            <td>{{scholar.RequestDate}}</td>
                                                            <td>{{scholar.Standard}}</td>
                                                            <td>{{scholar.Medium}}</td>
                                                            <td>{{scholar.InstituteType}}</td>
                                                            <td>{{scholar.AcademicYear}}</td>
                                                            <td>{{scholar.GrNo}}</td>
                                                            <!-- <td>{{scholar.StudName}}</td> -->
                                                            <td>{{scholar.ScholarshipType}}</td>
                                                            <td>{{scholar.Amount}}</td>
                                                            <td>{{scholar.StatusData}}</td>
                                                            <td>{{scholar.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="scholarshipDetcolleList == undefined || scholarshipDetcolleList.length == 0">
                                                        <tr>
                                                            <td colspan="10" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Rental Detail:</h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">RelationWith Owner</th>
                                                            <th scope="col">Yearly Amount Building</th>
                                                            <th scope="col">Yearly Amount PlayGround</th>
                                                            <th scope="col">Duration Of Deed</th>
                                                            <th scope="col">Date Of Deed</th>
                                                            <th scope="col">LastThree Year Amount</th>
                                                            <th scope="col">Bank Name</th>
                                                            <th scope="col">Account Number</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="PendingRentalcollwiseList != undefined && PendingRentalcollwiseList.length != 0">
                                                        <tr *ngFor="let Rental of PendingRentalcollwiseList">
                                                            <td>{{Rental.RequestDate}}</td>
                                                            <td>{{Rental.RelationWithOwner}}</td>
                                                            <td>{{Rental.YearlyRentAmountBuilding}}</td>
                                                            <td>{{Rental.YearlyRentAmountPlayGround}}</td>
                                                            <td>{{Rental.DurationOfRentDeed}}</td>
                                                            <td>{{Rental.DateOfRentDeed}}</td>
                                                            <td>{{Rental.LastThreeYearRentAmount}}</td>
                                                            <td>{{Rental.BankName}}</td>
                                                            <td>{{Rental.AccountNumber}}</td>
                                                            <td>{{Rental.StatusData}}</td>
                                                            <td>{{Rental.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="PendingRentalcollwiseList == undefined || PendingRentalcollwiseList.length == 0">
                                                        <tr>
                                                            <td colspan="11" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Construction Detail:</h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Year Of Construction</th>
                                                            <th scope="col">Phase</th>
                                                            <th scope="col">Area</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="PendingConstructioncollegewiseList != undefined && PendingConstructioncollegewiseList.length != 0">
                                                        <tr *ngFor="let con of PendingConstructioncollegewiseList">
                                                            <td>{{con.RequestDate}}</td>
                                                            <td>{{con.YearOfConstruction}}</td>
                                                            <td>{{con.Phase}}</td>
                                                            <td>{{con.Area}}</td>
                                                            <td>{{con.StatusData}}</td>
                                                            <td>{{con.Remark}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="PendingConstructioncollegewiseList == undefined || PendingConstructioncollegewiseList.length == 0">
                                                        <tr>
                                                            <td colspan="6" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Infrastructure Detail:</h6>

                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">No Of Infrastructure</th>
                                                            <th scope="col">Infrastructure Size</th>
                                                            <th scope="col">Infrastructure Type</th>
                                                            <th scope="col">Other Infrastructure Type</th>
                                                            <th scope="col">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="PendingInfrastructurecollegewiseList != undefined && PendingInfrastructurecollegewiseList.length != 0">
                                                        <tr *ngFor="let infa of PendingInfrastructurecollegewiseList">
                                                            <td>{{infa.RequestDate}}</td>
                                                            <td>{{infa.NoOfInfrastructure}}</td>
                                                            <td>{{infa.InfrastructureSize}}</td>
                                                            <td>{{infa.InfrastructureType}}</td>
                                                            <td>{{infa.OtherInfrastructure}}</td>
                                                            <td>{{infa.StatusData}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="PendingInfrastructurecollegewiseList == undefined || PendingInfrastructurecollegewiseList.length == 0">
                                                        <tr>
                                                            <td colspan="6" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Land Owner Detail :</h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>

                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Owner Name</th>
                                                            <th scope="col">Owner MailID</th>
                                                            <th scope="col">Owner MobileNo</th>
                                                            <th scope="col">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="PendingLandOwnercollList != undefined && PendingLandOwnercollList.length != 0">
                                                        <tr *ngFor="let Land of PendingLandOwnercollList">
                                                            <td>{{Land.RequestDate}}</td>
                                                            <td>{{Land.OwnerName}}</td>
                                                            <td>{{Land.OwnerMailID}}</td>
                                                            <td>{{Land.OwnerMobileNo}}</td>
                                                            <td>{{Land.StatusData}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="PendingLandOwnercollList == undefined || PendingLandOwnercollList.length == 0">
                                                        <tr>
                                                            <td colspan="5" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-12 mt-2">
                                        <div class="border border-dark bg-custom p-2">
                                            <div class="table-responsive">
                                                <table class="table table-bordered" style="font-size:7pt;">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <h6 class="mb-0 v_title">Classroom Detail:
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Request Date</th>
                                                            <th scope="col">Classroom Name</th>
                                                            <th scope="col">No Of ClassRoom</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody
                                                        *ngIf="ClassroomcollwiseList != undefined && ClassroomcollwiseList.length != 0">
                                                        <tr *ngFor="let cls of ClassroomcollwiseList">
                                                            <td>{{cls.RequestDate}}</td>
                                                            <td>{{cls.ClassroomName}}</td>
                                                            <td>{{cls.NoOfClassRoom}}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody
                                                        *ngIf="ClassroomcollwiseList == undefined || ClassroomcollwiseList.length == 0">
                                                        <tr>
                                                            <td colspan="3" style="text-align: center;">
                                                                No record found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
            <div class="footer-login custom-footer">
                <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
                <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
            </div>
            <!-- <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white;">Please Wait.</p>
        </ngx-spinner> -->
      
</div>